import { Component, ElementRef, QueryList, ViewChildren, inject } from "@angular/core";
import { ForgeListModule, PopoverConfig, PopoverRef } from "@tylertech/forge-angular";
import { ContextMenuData, ContextMenuItem } from "@tylertech/core-module";

@Component({
    selector: "app-menu-context-menu",
    imports: [
        ForgeListModule,
    ],
    templateUrl: "./contextmenu.tmpl.html"
})
export class ContextMenuComponent
{
    private readonly popoverRef = inject(PopoverRef);
    private readonly config = inject<PopoverConfig<ContextMenuData>>(PopoverConfig);

    protected currentIndex = 0;

    @ViewChildren("item") readonly menuItemElements: QueryList<ElementRef<HTMLButtonElement>>;

    private get anchorElement(): HTMLElement { return this.popoverRef.nativeElement.anchorElement as HTMLElement; }
    get contextItems(): ReadonlyArray<ContextMenuItem> { return this.config.data.items; }

    onClick($event: Event, item: ContextMenuItem): void
    {
        item.onClick($event);
    }

    onKeyUp($event: KeyboardEvent): void
    {
        const focusableCount = this.menuItemElements.length;
        const key = $event.key;

        if (key === "Tab")
        {
            $event.preventDefault();

            this.anchorElement.focus();
            this.popoverRef.close();
            return;
        }

        if (key === "ArrowUp")
        {
            this.currentIndex--;
            if (this.currentIndex < 0)
            {
                this.currentIndex = focusableCount - 1;
            }
        }

        if (key === "ArrowDown")
        {
            this.currentIndex++;
            if (this.currentIndex > focusableCount - 1)
            {
                this.currentIndex = 0;
            }
        }

        if (key === "Enter" || key === " ")
        {
            $event.preventDefault();
            const item = this.contextItems[this.currentIndex];
            item.onClick($event);
        }

        this.menuItemElements.get(this.currentIndex).nativeElement.focus();
    }
}
